import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { 
  Video, Calendar, Clock, Users, 
  Share2, Link as LinkIcon, ArrowRight 
} from 'lucide-react';

const DigiMeetLanding = () => {
  const navigate = useNavigate();

  const features = [
    {
      icon: <Video className="w-8 h-8" />,
      title: "Video Conferencing",
      description: "High-quality video meetings with screen sharing and recording capabilities"
    },
    {
      icon: <Calendar className="w-8 h-8" />,
      title: "Smart Scheduling",
      description: "Automated scheduling with availability management and timezone support"
    },
    {
      icon: <Clock className="w-8 h-8" />,
      title: "Meeting Duration",
      description: "Flexible meeting durations - 15, 30, 45, or 60 minutes"
    },
    {
      icon: <Users className="w-8 h-8" />,
      title: "Instant Meetings",
      description: "Create and join meetings instantly with unique meeting rooms"
    },
    {
      icon: <Share2 className="w-8 h-8" />,
      title: "Shareable Links",
      description: "Share your booking link for easy appointment scheduling"
    },
    {
      icon: <LinkIcon className="w-8 h-8" />,
      title: "Calendar Integration",
      description: "Sync with your calendar and manage all your meetings in one place"
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 via-white to-slate-50">
      <div className="container mx-auto px-4 py-16">
        <div className="text-center mb-16">
          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
            Digi<span className="text-purple-600">Meet</span>
          </h1>
          <p className="text-xl md:text-2xl text-gray-600 mb-8 max-w-3xl mx-auto">
            Seamless Video Conferencing & Smart Meeting Scheduling
          </p>
          <div className="flex gap-4 justify-center flex-wrap">
            <Button
              onClick={() => navigate('/auth')}
              className="bg-purple-600 hover:bg-purple-700 text-white px-8 py-6 text-lg rounded-full"
            >
              Start Meeting Free <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
            <Button
              onClick={() => navigate('/digi-meet')}
              variant="outline"
              className="px-8 py-6 text-lg rounded-full border-2 border-purple-600 text-purple-600 hover:bg-purple-50"
            >
              Explore Features
            </Button>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all border border-gray-100"
            >
              <div className="text-purple-600 mb-4">{feature.icon}</div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{feature.title}</h3>
              <p className="text-gray-600">{feature.description}</p>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-r from-purple-600 to-purple-700 rounded-3xl p-12 text-center text-white">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Ready to Meet Smarter?
          </h2>
          <p className="text-xl mb-8 opacity-90">
            Join professionals using DigiMeet for seamless collaboration
          </p>
          <Button
            onClick={() => navigate('/auth')}
            className="bg-white text-purple-600 hover:bg-gray-100 px-8 py-6 text-lg rounded-full font-semibold"
          >
            Get Started Now
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DigiMeetLanding;